module.exports = formatBasic

function formatBasic(code) {
  return '&#x' + code.toString(16).toUpperCase() + ';'
}
